import axios from 'axios';
import i18n from "@/i18n";

export default{
  async getCaptcha() {
    try {
      const res = await axios.get('auth/get_captcha');
      return res.data.captcha;
    } catch (error) {
      alert(i18n.t('更新驗證碼次數過多，請稍候再試'));
    }
  }
}